import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';


import ManageArtistsHeader from './manage-artists-header';
import TableComponent from 'common/components/table-component';
import { SelectColumnFilter,  NumberRangeColumnFilter, calcTimeSince } from 'common/components/table-component/table-component';


@inject('artistStore')
class ManageArtists extends React.Component {

	state = {
		searchTerm: ''
	}

	render () {
		const { artistStore } = this.props;
		const artistList = artistStore.filteredArtistList;
		const tableCols = [
			{
			Header: 'Basic Info',
			columns: [
				{
					Header: 'artistID',
					accessor: '_id',
					sortType: 'alphanumeric',
				},
				{
					Header: 'Artist',
					accessor: 'name',
					sortType: 'alphanumeric',
					Cell: ({value, row}) => { 
						console.log(value)
						console.log(row)
						const uID = artistStore.getArtistByID(row.values._id).userID;
						return 	<NavLink to={ `/artist/info/${row.values._id}` }>{value}</NavLink>
						// return <a href={`/#/artist/info/${uID}`}>{value}</a> 
					},
				},
				{
					Header: 'Label',
					accessor: 'label',
					Cell: ({value}) => { return value || '- No Label -'  },
					sortType: 'basic'
				},
				{
					Header: 'Genre',
					accessor: 'genre.label',
					id: 'genre',
					sortType: 'basic',
					Filter: SelectColumnFilter,
					filter: 'includes',
				},
				{
					Header: 'Join Date',
					accessor: 'createdAt',
					sortType: 'basic',
					Cell: ({value}) => { return moment(value).format('YYYY-MM-DD') + ` (${calcTimeSince(value)})` }
				},
				{
					Header: 'Catalog Size',
					accessor: 'songs.length',
					sortType: 'basic',
					Filter: NumberRangeColumnFilter,
					filter: 'between',
				},
			],
			},
			{
			Header: 'Subscriptions',
			columns: [
				{
					Header: 'MTD Subs',
					accessor: 'mtdSubs',
					sortType: 'basic'
				},
				{
					Header: 'YTD Subs',
					accessor: 'ytdSubs',
					sortType: 'basic'
				},
				{
					Header: 'Lifetime Subs',
					accessor: 'lifetimeSubs',
					sortType: 'basic'
				},
			],
			},
			{
			Header: 'Financial',
			columns: [
				{
					Header: 'Est. Monthly $',
					accessor: 'estMonthly',
					sortType: 'basic'
				},
				{
					Header: 'Est. Yearly $',
					accessor: 'estYearly',
					sortType: 'basic'
				},
			],
			},
		];

		return (
			<div className="grid-x">
				<div className="cell small-12">
					{/* <button onClick={(data) => this.state.filtersVisible ? this.setState({filtersVisible: false}) : this.setState({filtersVisible: true})} >{(this.state.filtersVisible ? 'Close' : 'Open') + ' Advanced Filtering'}</button> */}

					<ManageArtistsHeader 
						searchTerm={ this.state.searchTerm }
						searchChange={ this.searchChange }
					/>
				</div>

				<div 
					className="cell small-12" 
					style={{overflowX:"scroll", height:'60vh', paddingLeft: '1vw'}}	 
					data-ta="manageArtistsTable"
				>
					<TableComponent
						tableCols={ tableCols }
						data={ artistList }
						initialState={{
							pageIndex: 0,
							sortBy: [
							  {
								id: "name",
								desc: false
							  }
							],
							hiddenColumns: ["_id"],
							filtersVisible: true,
						}}
						//   getHeaderProps={column => ({
						// 	onClick: () => alert('Header!'),
						//   })}
						//   getColumnProps={column => ({
						// 	onClick: () => alert('Column!'),
						//   })}
						//   getRowProps={row => ({
						// 	style: {
						// 	  background: row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : 'white',
						// 	},
						//   })}
						//   getCellProps={cellInfo => ({
						// 	style: {
						// 	  backgroundColor: `hsl(${120 * ((120 - cellInfo.value) / 120) * -1 +
						// 		120}, 100%, 67%)`,
						// 	},
						//   })}
					/>
				</div>
			</div>
		);
	}

	@autobind
	searchChange2 ({ target }) {
		// this.applyFilter(target.value, "artistList");
		this.applyFilter(this.state.searchTerm, "artistList");
	}

	@autobind
	searchChange (event) {
		// this.applyFilter(target.value, "artistList");
		console.log("onchange: " + event.target.value);
		this.setState({searchTerm: event.target.value});
		
		const list = document.getElementById("artistList").children;
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			const txt = item.children[0].textContent;
			// if (txt.match(RegExp(event.target.value, "ig"))) {
			item.style = meetsFilter(event.target.value, name) ? {visibility: 'visible'} : {visibility: 'collapse', height: '0px !important'};
			// if (this.meetsFilter(event.target.value, txt))
			// 	// console.log(txt);
			// 	item.style = "visibility: visible;";
			// } else {
			// 	// console.warn(txt);
			// 	item.style = "visibility: collapse; height:0px !important;";
			// }
		}
    }

	@autobind
	applyFilter(filter, listID) {
		const list = document.getElementById(listID).children;
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			const txt = item.children[0].textContent;
			if (txt.match(RegExp(filter, "ig"))) {
				// console.log(txt);
				item.style = "visibility: visible;";
			} else {
				// console.warn(txt);
				item.style = "visibility: collapse; height:0px !important;";
			}
		}
	}
	
	@autobind
	meetsFilter(filter, txt) {
		if (txt.match(RegExp(filter, "ig"))) {
			return true;
		} else {
			return false;
		}
	}

	
}


export default ManageArtists;
